import { render } from "./esco-conversa-em-andamento-order.vue?vue&type=template&id=70cfbb4c&scoped=true"
import script from "./esco-conversa-em-andamento-order.vue?vue&type=script&lang=js"
export * from "./esco-conversa-em-andamento-order.vue?vue&type=script&lang=js"

import "./esco-conversa-em-andamento-order.vue?vue&type=style&index=0&id=70cfbb4c&lang=scss&scoped=true"
import "./esco-conversa-em-andamento-order.vue?vue&type=style&index=1&id=70cfbb4c&lang=scss"
import "./esco-conversa-em-andamento-order.vue?vue&type=style&index=2&id=70cfbb4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cfbb4c"]])

export default __exports__